<template>
  <div id="newsList">
    <div class="newsListDiv" :style="newsStyle">
      <a-skeleton active avatar :loading="loading" :title="false" :paragraph="{rows:5}" :style="loading?'padding:0 5%':''">
        <vue-seamless-scroll :data="scrollShowList" :class-option="seamlessOption"  class="seamless-warp">
          <a-list  itemLayout="vertical" :dataSource="showList" :pagination="listPagination" id="newsListItems" @mouseover="mouseOver" @mouseleave="mouseLeave">
            <a-list-item slot="renderItem" :style="index==0? 'padding: 40px 5% 0px':'padding:12px 5%'" slot-scope="item,index">
              <a-list-item-meta>
                <div slot="title" class="newsItemRow">
                  <div class="newsItemRowLeft">
                    <div class="newsAuthor">{{item.createName}}</div>
                    <news-type-label :newsType="item.informationType"></news-type-label>
                    <div class="newsTime">{{item.createTime | dayjs}}</div>
                    <div class="newsTime">{{filterCity(item.city)}}</div>
                  </div>
                  <div class="news_like" v-show="showOperation">

                    <!--收藏-->
                    <a slot="actions" class="news_like_icon" style="margin-bottom: 4px" @click="clickCollection(item)">
                      <pt-icon type="icon-a-xingzhuangcopy2" :title="$t('key83')" class="likeIcon" v-if="item.collection"></pt-icon>
                      <pt-icon type="icon-a-xingzhuangcopy4" :title="$t('key82shoucang')" class="likeIcon" v-else></pt-icon>
                    </a>

                    <!--评论-->
                    <a slot="actions" class="news_like_icon" @click="openComment(item)">
                      <pt-icon type="icon-pinglun" class="likeIcon"  :title="$t('keypinglun')" v-if="!item.selfComment"></pt-icon>
                      <pt-icon type="icon-youpinglun" class="likeIcon"  :title="$t('keypinglun')" v-else></pt-icon>
                      <div>{{item.commentCount}}</div>
                    </a>
                    <!--赞-->
                    <a slot="actions" class="news_like_icon" @click="clickLike(item)">
                      <pt-icon type="icon-zan1" class="likeIcon"  :title="$t('baseVO.cancelLike')" v-if="filterLike(item.newsLikeDOS)"></pt-icon>
                      <pt-icon type="icon-zan2" class="likeIcon" :title="$t('baseVO.like')" v-else></pt-icon>
                      <div>{{item.newsLikeDOS != null ? item.newsLikeDOS.filter(e=>e.type == 1).length : 0}}</div>
                    </a>
                    <!--不赞-->
                    <a slot="actions" class="news_like_icon" @click="clickDisLike(item)">
                      <pt-icon type="icon-zan" class="likeIcon" :title="$t('baseVO.cancelNoLike')" v-if="filterDislike(item.newsLikeDOS)"></pt-icon>
                      <pt-icon type="icon-GroupCopy1" class="likeIcon" :title="$t('baseVO.noLike')" v-else></pt-icon>
                      <div>{{item.newsLikeDOS != null ? item.newsLikeDOS.filter(e=>e.type == 0).length : 0}}</div>
                    </a>
                  </div>
                </div>
                <a-avatar
                  slot="avatar"
                  icon="user"
                  class="userImage"
                  :size="size"
                  :src="getImageUrl(item.createImg)"
                />
              </a-list-item-meta>
              <div class="newsContentDiv" :style="{marginLeft:size+'px'}" @click="openDrawer(item)">
                <i class="contentArrow"></i>


                <div class="newsContent">
                  <span  class="" style="white-space: nowrap;" v-if="item.confidentialityStatus == 1">
                    <span style="background: #fabe00;font-size:12px;color:#333333;border-radius: 2px;margin-right: 3px;white-space: nowrap;padding: 0px 3px">{{ $t('key83baomi') }}</span>
                  </span>
                  <span  class="" v-if="item.type == 2">
                    <span style="background: #0481E1;font-size:12px;color:#ffffff;border-radius: 2px;margin-right: 3px;white-space: nowrap;margin-right: 30px;padding: 0px 3px">{{$t('residentProjects.news')}}</span>
                  </span>
                  <span>
                    <pre v-html="getnewsContent(item)" style="white-space: pre-wrap;word-break: break-word;margin-bottom: 0px"></pre>
                  </span>
                </div>
                <newsCommentComponent :formToken="formToken" :item="item" @cancelComment="cancelComment" @submitComment="submitComment" @delete="deleteComment" @saveSuccess="saveSuccess"></newsCommentComponent>
              </div>
            </a-list-item>
          </a-list>
        </vue-seamless-scroll>
      </a-skeleton>
    </div>
  </div>
</template>

<script>
  import newsLikeApi from '@/api/mine/newsLike'
  import newsTypeLabel from './newsTypeLabel'
  import vueSeamlessScroll from 'vue-seamless-scroll'
  import {getDatadictChildsByPath} from '@/api/sys/datadict'
  import unitApi from '@/api/manager/unit'
  import newsCommentComponent from './newsCommentComponent'
  import UserApi from '@/api/sys/user'
  import collectionApi from '@/api/mine/collection'
  import newsApi from "@/api/mine/news";
  export default {
    name: 'newsList',
    components:{
      newsTypeLabel,vueSeamlessScroll,newsCommentComponent
    },
    props: {
      loading:{
        type: Boolean,
        default: false,
      },
      collectionFlag:{
        type: Boolean,
        default: false,
      },
      newsList:{
        type:Array,
        default:()=>{ return [] }
      },
      listPagination:{
        type:Object,
        default:()=>{return null}
      },
      startAnimate:{
        type:Boolean,
        default:false,
      },
      newsStyle:{
        type:Object,
        default:()=>{return {}}
      },
      size:{
        type: [String, Number],
        default:45,
      },
      showOperation:{
        type:Boolean,
        default:true,
      }
    },
    data() {
      return {
        newsCommentDO: this.$form.createForm(this,{}),
        cityData:[],
        unitAllData:[],
        formToken:'',
        showList:[],
        scrollShowList:[],
        animationStyle:'',
        seamlessOption:{
          step: 0.5, //步长 越大滚动速度越快
          limitMoveNum: 3, //启动无缝滚动最小数据量 this.dataList.length
          hoverStop: true, //是否启用鼠标hover控制
          direction: 1, //1 往上 0 往下
          openWatch: true, //开启data实时监听
          singleHeight: 0, //单条数据高度有值hoverStop关闭
          waitTime: 1000, //单步停止等待时间
          switchDisabledClass:'test',
        }
      }
    },
    mounted() {
      this.init()
      this.initFormToken();
    },
    methods: {
      clickCollection(item){
        this.submitCollection({type:1,newsId:item.id, newsCreaterId:item.createrId},item)
      },

      initFormToken(){
        UserApi.getFormToken().then(res=>{
          if(res.code == 1){
            this.formToken = res.data;
          }
        })
      },
      saveSuccess(item){
        item.commentCount++
        item.selfComment = true
      },
      deleteComment(){
        this.$emit('refreshList')
      },
      cancelComment(item){
        this.$set(item,'isCommentEnter',false)
      },
      submitComment(item){
        this.initFormToken();
        this.$set(item,'isCommentEnter',false)
      },
      init(){
        this.initAllUnit()
        this.initCityData();
      },
      initCityData(){
        getDatadictChildsByPath('system.business_key.news_setup').then(res=>{
          this.cityData = res.data
          // this.initCityDatas(res.data)
        })
      },
      initCityDatas(datas){
        this.cityData = [];
        newsApi.getUserCitys().then((res)=>{
          let citys = res.data;
          if(citys.length !== 0){
            citys.forEach(data=>{
              datas.forEach(dictData=>{
                if(data == dictData.wordKey){
                  this.cityData.push(dictData)
                }
              })
            })
          }else{
            this.cityData = datas;
          }
        })
      },
      initAllUnit(){
        unitApi.selectAll().then(res=>{
          if(res.code == 1){
            this.unitAllData= res.data ? res.data:[]
          }
        })
      },
      filterUnit(unitId){
        let curUnit = this.unitAllData.find(data =>{
          return data.id == unitId
        })
        if(curUnit){
          return curUnit.shortName;
        }else{
          return '';
        }
      },
      openComment(item){
        this.initFormToken();
        this.$set(item,'isCommentEnter',item.isCommentEnter != null ? !item.isCommentEnter : true)
        // item.isCommentEnter = true; //由评论按钮打开动态详情 isCommentEnter 为true
        // this.$emit('openDrawer',item)
      },
      filterCity(cityId){
        let city;
        city = this.cityData.find(e=>{ return e.wordKey == cityId})
        return city != null ? city.wordValue : ''
      },
      filterLike(likeData){
        let me = this.$store.getters.userInfo.accountDO.id;
        let visible = false;
        if(likeData != null && likeData.length > 0){
          likeData.filter(e=>{
            return e.type == 1
          }).forEach((item,index) => {
            if(item.createrId == me){
              visible = true;
            }
          })
        }
        return visible;
      },
      filterCollection(likeData){
        let me = this.$store.getters.userInfo.accountDO.id;
        let visible = false;
        if(likeData != null && likeData.length > 0){
          likeData.filter(e=>{
            return e.type == 1
          }).forEach((item,index) => {
            if(item.createrId == me){
              visible = true;
            }
          })
        }
        return visible;
      },
      filterDislike(likeData){
        let me = this.$store.getters.userInfo.accountDO.id;
        let visible = false;
        if(likeData != null && likeData.length > 0){
          likeData.filter(e=>{
            return e.type == 0
          }).forEach((item,index) => {
            if(item.createrId == me){
              visible = true;
            }
          })
        }
        return visible;
      },
      getnewsContent(newsDO){
        let content = ''
        if(newsDO.displayContent != '~'){
          if(newsDO.confidentialityStatus == 1){
            return '<span style="margin-right: 30px"></span>'+newsDO.displayContent;
          }else{
            return newsDO.displayContent;
          }
        }else{
          if(newsDO.informationType == '交易记录'){
            let dealTypes = newsDO.dealType.split(',')
            content = newsDO.customerName
            let dealTypesArr = []
            dealTypes.forEach(e=>{
              dealTypesArr.push(this.$t('deal.dealTypes.' + e))
              // content += this.$t('deal.dealTypes.' + e)
            })
            content += dealTypesArr.join(',')
            content += newsDO.newBuilding != '~' ? newsDO.newBuilding : ''
            content += newsDO.newArea != '~' ? this.$t('news.content.newsArea') + newsDO.newArea + this.filterUnit(newsDO.newAreaUnit): ''
            content += (newsDO.startTime != '~') ? this.$t('news.content.startTime') + this.$moment(newsDO.startTime).format('YYYY-MM-DD') : ''
            content += newsDO.rent != '~' ? this.$t('news.content.newRent') + newsDO.rent + this.filterUnit(newsDO.rentUnit): ''
            content += newsDO.increasing != '~' ? ',' + newsDO.increasing + this.$t('news.content.increasing') : ''
            content += newsDO.rentFreePeriod != '~' ? this.$t('news.content.newRentFreePeriod') + newsDO.rentFreePeriod + this.$t('news.content.months'):''
            content += newsDO.intermediaryStr != '~' ? this.$t('news.content.intermediary') + newsDO.intermediaryStr : ''
          }else{
            if(newsDO.confidentialityStatus == 1){
              return '<span style="margin-right: 30px"></span>'+ (newsDO.displayContent != '~' ? newsDO.displayContent : newsDO.content)
            }else{
              content = newsDO.displayContent != '~' ? newsDO.displayContent : newsDO.content
            }
          }
          return content
        }
      },
      clickDisLike(item){
        this.submitNewsLike({type:0,newsId:item.id, newsCreaterId:item.createrId},item)
      },
      clickLike(item){
        this.submitNewsLike({type:1,newsId:item.id, newsCreaterId:item.createrId},item)
      },
      mouseOver(){
        document.getElementById('newsListItems').style.cssText = this.animationStyle + "animation-play-state: paused;"
      },
      mouseLeave(){
        document.getElementById('newsListItems').style.cssText = this.animationStyle + "animation-play-state: running;"
      },
      openDrawer(item){
        item.isCommentEnter = false;
        this.$emit('openDrawer',item)
      },
      pageChange(value){
        this.$emit('pageChange',value)
      },
      getImageUrl(headimg){
        return this.$util.getFileUrl(headimg)
      },
      submitNewsLike(obj,item){
        newsLikeApi.clickNewsLike(obj).then(res=>{
          if(res.code == 1){
            item.newsLikeDOS = res.data == null ? [] : res.data
            // this.$emit('refreshList')
            this.$message.success(res.message)
          }else{

          }
        })
      },
      submitCollection(obj,item){
        let _this = this
        let newsCollection = {
          newsId:obj.newsId
        }
        if(item.collection == true || _this.collectionFlag ){
          _this.$ptConfirm({
            title: _this.$t('expense.collectionRevoke.title'),
            content: _this.$t('expense.collectionRevoke.content'),
            okType: 'primary',
            icon:true,
            onOk() {
              item.collection = !item.collection
              _this.$message.success(_this.$t('expense.collectionCancelled'))
              collectionApi.saveOrUpdate(newsCollection).then(res => {
                if(res.code == 1 ){
                  console.log('_this.collectionFlag',_this.collectionFlag)
                  if(_this.collectionFlag){
                    _this.$emit('refreshList')
                  }
                }
              })
            }, onCancel() {
            },
          })
        }else{
          item.collection = !item.collection
          _this.$message.success(_this.$t('expense.collectionSuccess'))
          collectionApi.saveOrUpdate(newsCollection).then(res => {
            if(res.code == 1 ){
              console.log('_this.collectionFlag',_this.collectionFlag)
              if(_this.collectionFlag){
                _this.$emit('refreshList')
              }
            }
          })
        }
      },
    },
    watch:{
      newsList(){
        console.log("市场动态变化")
        if(this.newsList.length > 0){
          if(this.startAnimate && this.newsList.length > 3){
            this.showList = [...this.newsList,...this.newsList]
            this.scrollShowList = [...this.newsList,...this.newsList]
          }else{
            this.showList = this.newsList
            this.scrollShowList = []
          }
        }else{
          this.showList = []
          this.scrollShowList = []
        }
      }
    }
  }
</script>

<style scoped lang="less">
  @keyframes images {
    0% { transform: scale(1)}
    100% {transform: scale(2.5)  }
  }
  @keyframes images1 {
    0% { transform: scale(2.5)}
    100% {transform: scale(1)  }
  }
  #newsList{
    .userImage{
      width: 45px;
      height: 45px;
      z-index: 999;
      transform-origin: center 57%;
      transition: all 0.5s ease;
    }
    .userImage:hover{
        transform-origin: center 57%;
        z-index: 999;
        transform: scale(2.5);
        transition: all 0.5s ease;
        box-shadow: 0 2px 4px 0px rgba(59,46,38,0.42);
    }
    .loadingClass{
      min-height: 150px;
    }
    .newsListDiv{
      overflow: hidden;
      margin-bottom: 20px;

      .newsItemRow{
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: center;
        .newsItemRowLeft{
          display: flex;
          flex-direction: row;
          align-items: center;
        }
        .newsAuthor{
          font-size: 14px;
          color: #4D4D4D;
          width: 120px;
          margin-right: 10px;
        }
        .newsTime{
          margin-left: 30px;
          font-size: 14px;
          color: #909090;
        }
      }
      .ant-list-split .ant-list-item{
        border-bottom: 0px !important;
      }
      .ant-list-vertical .ant-list-item-meta{
        margin-bottom: 0px !important;
      }
      .ant-list-vertical .ant-list-item-meta-title{
        margin-bottom: 4px !important;
      }
      .secrecyIcon{
        margin-left: 20px;
      }
      .newsContentDiv{
        cursor: pointer;
        position: relative;
        margin-left: 45px;
        padding-bottom: 20px;
        margin-top: 5px;
        /*border-bottom: 1px solid #E7E7E7;*/
      }
      .contentArrow{
        position: absolute;
        border: 10px solid rgba(0,0,0,0);
        height: 0;
        line-height: 0;
        font-size: 0;
        top: -14px;
        left: 0;
        border-bottom-color:rgba(244,245,248,0.6);
        border-left-color:rgba(244,245,248,0.6);
      }
      .newsContent{
        word-break:break-all;
        overflow-wrap: break-word;
        padding: 20px 20px 0 20px;
        background: rgba(244,245,248,0.6);
        border-radius: 0 0 5px 5px;
        font-size: 14px;
        color: #323232;
        letter-spacing: 1px;
        text-align: justify;
        line-height: 24px;
        word-wrap: break-word;
      }
    }
    .news_like{
      display: flex;
      .news_like_icon{
        display: flex;
        justify-content: center;
        align-items: center;
        margin-right: 20px;
        div{
          color: #6D6B6A;
          margin-left: 6px;
          font-size: 14px;
          font-weight: 500;
        }
        .commentIcon{
          cursor:pointer;
          font-size: 14px;
        }
        .likeIcon{
          cursor:pointer;
          font-size: 14px;
        }
      }
      .news_like_icon .likeIcon:hover{
        transform: scale(1.2);
      }
    }
  }
</style>
<style lang="less">
  .seamless-warp {
    >div{
      width: 100% !important;
    }
  }
</style>